const showEuroCurrency = function (amount, country = 'de-DE', currency = 'EUR') {
  return new Intl.NumberFormat(country, { style: 'currency', currency: currency }).format(amount);
};


export { showEuroCurrency }
